"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = clearSuggestedActions;
exports.CLEAR_SUGGESTED_ACTIONS = void 0;
var CLEAR_SUGGESTED_ACTIONS = 'WEB_CHAT/CLEAR_SUGGESTED_ACTIONS';
exports.CLEAR_SUGGESTED_ACTIONS = CLEAR_SUGGESTED_ACTIONS;

function clearSuggestedActions() {
  return {
    type: CLEAR_SUGGESTED_ACTIONS
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2NsZWFyU3VnZ2VzdGVkQWN0aW9ucy5qcyJdLCJuYW1lcyI6WyJDTEVBUl9TVUdHRVNURURfQUNUSU9OUyIsImNsZWFyU3VnZ2VzdGVkQWN0aW9ucyIsInR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSx1QkFBdUIsR0FBRyxrQ0FBaEM7OztBQUVlLFNBQVNDLHFCQUFULEdBQWlDO0FBQzlDLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFRjtBQURELEdBQVA7QUFHRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TID0gJ1dFQl9DSEFUL0NMRUFSX1NVR0dFU1RFRF9BQ1RJT05TJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY2xlYXJTdWdnZXN0ZWRBY3Rpb25zKCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TXG4gIH07XG59XG5cbmV4cG9ydCB7IENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TIH07XG4iXX0=